import { gql } from '@apollo/client';

const GET_ORG_UNIT_SHARED_DATA = gql`
  query GetOrgUnitSharedData($orgUnitId: Int!) {
    mddapOrgUnitFdaSharing(orgUnitId: $orgUnitId) {
      MddapOrgUnitId
      ModifiedBy
      SharedPerformanceReports {
        MddapCheckpointPerformanceItemId
      }
      SharedDetailedAppraisalReports {
        AppraisalId
      }
      SharedPracticeCharacterizationReports {
        AppraisalId
      }
    }
  }
`;

export default GET_ORG_UNIT_SHARED_DATA;
